export default __webpack_public_path__ + "static/media/gallery_06.10b84058.jpg";